import DashboardPage from "../pages/DashboardPage";
import RolesAndPermissionsPage from "../pages/RolesAndPermissionsPage";
import UsersPage from "../pages/UsersPage";
import PaymentMethodsPage from "../pages/PaymentMethodsPage";
import TaxCodesPage from "../pages/TaxCodesPage";
import ProductsPage from "../pages/ProductsPage";
import ReceiptsPage from "../pages/ReceiptsPage";
import CustomersPage from "../pages/CustomersPage";
import ReceiptPage from "../pages/ReceiptPage";
import InvoicesPage from "../pages/InvoicesPage";
import InvoicePage from "../pages/InvoicePage";
import CreditNotesPage from "../pages/CreditNotesPage";
import CreditNotePage from "../pages/CreditNotePage";
import PaymentsPage from "../pages/PaymentsPage";
import SequencesPage from "../pages/SequencesPage";
import DocumentHeadersPage from "../pages/DocumentHeadersPage";
import ReminderLogsPage from "../pages/ReminderLogsPage";
import FiscalItemsPage from "../pages/FiscalItemsPage";
import FiscalInvoicesPage from "../pages/FiscalInvoicesPage";
import FiscalInvoicePage from "../pages/FiscalInvoicePage";
import LicensesPage from "../pages/LicensesPage";

// --- All entries must be component references ---
const RouteToComponentMapper = {
  DASHBOARD: DashboardPage,

  // Operations
  LICENSES: LicensesPage,
  RECEIPTS: ReceiptsPage,
  RECEIPT: ReceiptPage,
  INVOICES: InvoicesPage,
  INVOICE: InvoicePage,
  CREDIT_NOTES: CreditNotesPage,
  CREDIT_NOTE: CreditNotePage,

  // Catalog
  PRODUCTS: ProductsPage,

  // CRM
  CUSTOMERS: CustomersPage,

  // Finance
  PAYMENTS: PaymentsPage,

  FISCAL_ITEMS: FiscalItemsPage,
  FISCAL_INVOICES: FiscalInvoicesPage,
  FISCAL_INVOICE: FiscalInvoicePage,

  // Admin
  USERS: UsersPage,
  ROLES: RolesAndPermissionsPage,
  TAX_CODES: TaxCodesPage,
  PAYMENT_METHODS: PaymentMethodsPage,
  DOCUMENT_HEADERS: DocumentHeadersPage,
  SEQUENCES: SequencesPage,
  REMINDERS: ReminderLogsPage,
};

export default RouteToComponentMapper;
